import { Component, Input, OnInit } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { AtwUpdateDbComponent } from 'vhobjects-service';
import { FunctionService  } from 'vhobjects-service';

@Component({
  selector: 'atw-text-price-sale-admin-config',
  templateUrl: './text-price-sale-admin-config.component.html',
  styleUrls: ['./text-price-sale-admin-config.component.scss']
})
export class AtwTextPriceSaleAdminConfig extends AtwUpdateDbComponent implements OnInit {
  @Input() data_tool: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() type_config : string; // xác định trang đang ở page hay preview
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;
  @Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  styles_field = [
    {
      title: 'hieu_ung_chuyen_dong',
      index: 1,
    }
  ];
  
  effect_hover = [];
  effect_hover_data: any = {};
  configMode: 'basic' | 'advanced' = 'basic';

  // private textFormatDiffer: KeyValueDiffer<string, any>;
  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient, 
    public vhEventMediator: VhEventMediator,
        public functionService: FunctionService
     ) {
    super(vhQueryAutoWeb, vhEventMediator, functionService);
     }

  ngOnInit(): void {
    
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/text.json'), 
    ]) .subscribe(([ effects]:any)=>{
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    })

    // Kiểm tra đã chọn Phong cách hay chưa
    // if(!this.class['text-price-sale__content']['text-shadow']
    //   && !this.class['text-price-sale']['background-color']
    //   && this.class['text-price-sale__content']['-webkit-text-stroke-width'] == 0) {
    //     this.dispatchStyles('');
    // }
  }

  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }  
  }

  customize = []

  // /**
  //  * Hàm update object vào database.
  //  */
  // updateObject() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
  //     .then((bool: any) => {
        
  //     })
  // }

  // /**
  //  * Hàm update class
  //  */
  // updateClass() {
  //   this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
  //     .then((bool: any) => {
        
  //     })
  // }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại. 
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false
  };

  /**
   * Hàm này set customize mở mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    if (this.config['animation-selected'].id != '000000') {
      this.openViewAll(this.styles_field[0]);
    }
  }
}
